import React from "react";
import styles from "./box.module.scss";
// import family from '../../../assets/family.JPG'
// import blog from '../../../assets/blog-events.jpg'
import { Link } from "react-router-dom";
import { GoDotFill } from "react-icons/go";
// import analog_horizon from "../../../assets/row-medical-analog-horizon.jpg";
import sales_marketing from '../../../assets/sales_marketing.jpg';
import sales_marketing_2 from '../../../assets/sales_marketing_2.jpg';
import project_manager from '../../../assets/project-manager.jpg';
import imaging_development from '../../../assets/imaging_development.jpg';
import web_development from '../../../assets/web_development.jpg';
import it from '../../../assets/it.jpg';

const Box = ({job}) => {
  return (
    <section className={styles.box_container}>
      <div className={styles.___container}>
        {/* Box 1  */}
        {   job === 'Sales / Marketing' &&     
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={sales_marketing} alt='sales_marketing' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              Job Title : Healthcare IT sales (HIS / LIS / PACS)
              </Link>
              <strong className={styles.__strong}>
              Job Requirements:
              </strong>
              <ul className={styles.__bullets}>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      B. Sc. in Medicine, Engineering or Business.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Perfect command of English , French is as advantage.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Min. three years experience in selling hospital and clinical software applications.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      market opening and selling skills are an advantage.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Good communication skills and presentable
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Hard worker and able to travel outside abroad.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Own a car and driving license is an advantage.
                </li>
              </ul>
              <strong className={styles.__strong}>Location</strong>
              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Riyadh : Saudi Arabia.
                  </Link>
                </li>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Jeddah: Saudi Arabia.
                  </Link>
                </li>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Cairo : Egypt.
                  </Link>
                </li>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Alexandria : Egypt. 
                  </Link>
                </li>
              </ul>
              <button className={styles["product___btn"]}>
                <a href={`mailto:hr@millensys.com?Subject=Application for ${job} Job`}>
                  Send Your CV To: hr@millensys.com
                </a>
              </button>
            </div>
          </div>
        </div>}

        {/* Box 2  */}
        {   job === 'Sales / Marketing' &&
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              Job Title : ERP / CRM / HRM sales
              </Link>
              <strong className={styles.__strong}>
              Job Requirements:
              </strong>
              <ul className={styles.__bullets}>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      B. Sc. in Business or commerce. 
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Perfect command of English.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Min. one years experience in selling ERP financial and CRM software applications.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      market opening and selling skills are an advantage.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Good communication skills and presentable.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Hard worker and able to travel outside abroad.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Own a car and driving license is an advantage.
                </li>
              </ul>
              <strong className={styles.__strong}>Location</strong>
              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Cairo : Egypt.
                  </Link>
                </li>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Riyadh : Saudi Arabia.
                  </Link>
                </li>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Jeddah: Saudi Arabia.
                  </Link>
                </li>
              </ul>
              <button className={styles["product___btn"]}>
                <a href={`mailto:hr@millensys.com?Subject=Application for ${job} Job`}>
                  Send Your CV To: hr@millensys.com
                </a>
              </button>
            </div>

            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={sales_marketing_2} alt='sales_marketing_2' loading="lazy"/>
              </div>
            </div>
          </div>
        </div>}

        {/* Box 3  */}
        {   job === 'Projects / Implementation' &&
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={project_manager} alt='project-manager' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              Job Title : Project Manager (Healthcare / Commercial)
              </Link>
              <strong className={styles.__strong}>
              Job brief:
              </strong>
              <p className={styles.__content}>We are looking for an experienced Project Manager to manage organization of key client projects.</p>
              <strong className={styles.__strong}>
              Job Duties:
              </strong>
              <p className={styles.__content}>
                Project management responsibilities include delivering every project on time within budget and scope. Project managers should have
                a background in business skills, management, budgeting and analysis.
              </p>
              <strong className={styles.__strong}>
              Responsibilities:
              </strong>
              <ul className={styles.__bullets}>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Coordinate internal resources and third parties/vendors for the flawless execution of projects
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Ensure that all projects are delivered on-time, within scope and within budget
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Developing project scopes and objectives, involving all relevant stakeholders and ensuring technical feasibility
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Ensure resource availability and allocation
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Develop a detailed project plan to track progress
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Use appropriate verification techniques to manage changes in project scope, schedule and costs
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Measure project performance using appropriate systems, tools and techniques
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Report and escalate to management as needed
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Manage the relationship with the client and all stakeholders
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Perform risk management to minimize project risks
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Establish and maintain relationships with third parties/vendors
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Create and maintain comprehensive project documentation
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Ability to execute project overseas.
                </li>
              </ul>
              <strong className={styles.__strong}>
              Requirements:
              </strong>
              <ul className={styles.__bullets}>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      B. Sc. in computer science or engineering.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Perfect command of English , French is an advantage.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Min. five years experience in Hospital / Financial software IT project management field.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Proven working experience as a project administrator in the information technology sector
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Solid technical background, with understanding or hands-on experience in software development and web technologies
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Excellent client-facing and internal communication skills
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Solid organizational skills including attention to detail and multi-tasking skills
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Strong working knowledge of Microsoft Office
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      PMP certification is a plus
                </li>
              </ul>
              <strong className={styles.__strong}>Location</strong>
              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Cairo , Egypt
                  </Link>
                </li>
              </ul>
              <button className={styles["product___btn"]}>
                <a href={`mailto:hr@millensys.com?Subject=Application for ${job} Job`}>
                  Send Your CV To: hr@millensys.com
                </a>
              </button>
            </div>
          </div>
        </div>}
        {/* Box 1-2  */}
        {   job === 'Software Development' &&
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={web_development} alt='web_development' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              Job Title : Web Development
              </Link>
              <strong className={styles.__strong}>
              Job Requirements:
              </strong>
              <ul className={styles.__bullets}>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      B. Sc. Computer, Science or Commerce.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Perfect command of English.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Min. two years experience in programming.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Experience in  MSSQL,C#, MVC , ASP,Java script,HTML5, .Net.,
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Experience in Mobile web developments
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Good communication skills and presentable.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Team Worker and able to work under stress.
                </li>
              </ul>
              <strong className={styles.__strong}>Location</strong>
              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Cairo : Egypt.
                  </Link>
                </li>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Alexandria : Egypt. 
                  </Link>
                </li>
              </ul>
              <button className={styles["product___btn"]}>
                <a href={`mailto:hr@millensys.com?Subject=Application for ${job} Job`}>
                  Send Your CV To: hr@millensys.com
                </a>
              </button>
            </div>
          </div>
        </div>}

        {/* Box 2-2  */}
        {   job === 'Software Development' &&
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              Job Title :  Imaging Development 
              </Link>
              <strong className={styles.__strong}>
              Job Requirements:
              </strong>
              <ul className={styles.__bullets}>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      B. Sc. Computer, Biomedical or Communications Engineering.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Perfect command of English.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Min. two years experience in programming with math.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Experience in  Delphi,Java script,HTML5,C#,  .Net,VC, openGL.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      knowledge in image processing (2D/3D) and math. is an advantage.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Experience in Mobile  developments
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Good communication skills and presentable.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Team Worker and able to work under stress.
                </li>
              </ul>
              <strong className={styles.__strong}>Location</strong>
              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Cairo : Egypt.
                  </Link>
                </li>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Alexandria : Egypt.
                  </Link>
                </li>
              </ul>
              <button className={styles["product___btn"]}>
                <a href={`mailto:hr@millensys.com?Subject=Application for ${job} Job`}>
                  Send Your CV To: hr@millensys.com
                </a>
              </button>
            </div>

            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={imaging_development} alt='imaging_development' loading="lazy"/>
              </div>
            </div>
          </div>
        </div>}

        {/* Box 4  */}
        {   job === 'Technical Support' &&
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={it} alt='web_development' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              Job Title : Service Engineer
              </Link>
              <strong className={styles.__strong}>
              Job Requirements:
              </strong>
              <ul className={styles.__bullets}>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      B. Sc. IT/Communication/Biomedical Engineering.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Perfect command of English , French is an advantage.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Min. two years experience in IT field.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Experience in Computer/Server preparation, installation and configuration, Network configuration.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Database management is an advantage.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Good communication skills and presentable.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Hard worker and able to travel outside abroad.
                </li>
                <li>
                      <GoDotFill className={styles.__bullet_dot} />{' '}
                      Own a car and driving license is an advantage.
                </li>
              </ul>
              <strong className={styles.__strong}>Location</strong>
              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Cairo : Egypt.
                  </Link>
                </li>
              </ul>
              <button className={styles["product___btn"]}>
                <a href={`mailto:hr@millensys.com?Subject=Application for ${job} Job`}>
                  Send Your CV To: hr@millensys.com
                </a>
              </button>
            </div>
          </div>
        </div>}



      </div>
    </section>
  );
};

export default Box;
